var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"format",on:{"click":_setup.onTemplateAreaClick}},[_c('div',{staticClass:"renew3_wrapper format_wrapper"},[_c(_setup.TopPopularFormats),_c(_setup.TopRecommendedFormats)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }